import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, andamentoProcesso } from './types';

export const INITIAL_STATE: andamentoProcesso = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): andamentoProcesso {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ANDAMENTO_PROCESSO_REQUEST: {
				break;
			}

			case Types.ANDAMENTO_PROCESSO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.ANDAMENTO_PROCESSO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.ANDAMENTO_PROCESSO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
